import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { CORE_ROUTE, CustomerManagementSelector, JurisdictionSelector } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";
import { ignoreNil } from "@obg/rxjs";
import { combineLatest, Observable, of } from "rxjs";
import { map } from "rxjs/operators";

import { CommonState } from "../state";

import { LoyaltyConfigService } from "./loyalty.config";

@Injectable({
	providedIn: "root",
})
export class LoyaltyGuard implements CanActivate {
	constructor(
		private store: Store<CommonState>,
		private config: LoyaltyConfigService
	) {}

	canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
		const isEnabled = this.config.isEnabled();

		if (!isEnabled) {
			this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home));
			return of(false);
		}

		return combineLatest([
			this.store.pipe(
				select(CustomerManagementSelector.getCustomer),
				ignoreNil(),
				map((customer) => customer.address.country)
			),
			this.store.pipe(select(JurisdictionSelector.get), ignoreNil()),
		]).pipe(
			map(([customerCountry, jurisdiction]) => {
				const blockedJurisdictions = this.config.getBlockedJurisdictions();
				const blockedCountries = this.config.getBlockedCountries();

				if (
					blockedJurisdictions.find(
						(blockedJurisdiction) => blockedJurisdiction.toLowerCase() === jurisdiction?.toLowerCase()
					) ||
					blockedCountries.find(
						(blockedCountry) => blockedCountry.toLowerCase() === customerCountry?.toLowerCase()
					)
				) {
					this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home));
					return false;
				}

				return true;
			})
		);
	}
}
